module.exports = __webpack_public_path__ + "static/img/ma6.6bba20e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma6.gif
// module id = n06E
// module chunks = 1